import script from "./EmailType.vue?vue&type=script&lang=js"
export * from "./EmailType.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__